import { Formie } from '../../../../../vendor/verbb/formie/src/web/assets/frontend/dist/js/formie';
import '../../../../../vendor/verbb/formie/src/web/assets/frontend/dist/css/formie-base.css';
import '../../../../../vendor/verbb/formie/src/web/assets/frontend/dist/css/formie-theme.css';


export default () => {

    

    // console.log('FormieInit1');
    
    // window.Formie.initForms();

    // document.addEventListener('DOMContentLoaded', (event) => {

    //     let forms = document.getElementsByClassName('fui-form');
    //     let i;
    //     for (i=0; i < forms.length; i++) {
    //         // window.Formie.destroyForm(forms[i]);
    //         window.Formie.initForms();
    //     };
    // });

    

    
    // let footerForm = document.getElementById('footerNewsletter');
    // footerForm.addEventListener('onFormieSubmitError', (e) => {
    //     console.log('Newsletter error');
    //     console.log(e);
    // });

    // console.log('Formie.js');
}